import axios from "axios";

// Same-origin API base: the frontend and backend are served from the same host via ingress,
// so a relative "/api" base makes the bundle work identically on any host (custom domain
// horsetips4fun.com, preview URL, or future hosts) with no CORS and SameSite=Lax cookies.
export const API_BASE = "/api";

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiError(detail, fallback = "Something went wrong. Please try again.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/** Convert an axios error into a human-readable diagnostic. */
export function describeAxiosError(err) {
  if (!err) return "Unknown error.";
  // Network / CORS / timeout: no response object at all
  if (!err.response) {
    if (err.code === "ECONNABORTED") return "Request timed out — check your connection and try again.";
    if (err.message && err.message.toLowerCase().includes("network"))
      return "Network error — the server didn't respond. Check your internet connection and try again.";
    return "Could not reach the server — check your internet connection and try again.";
  }
  // HTTP error with a body
  const status = err.response.status;
  const detail = err.response.data?.detail;
  if (detail) return formatApiError(detail);
  if (status >= 500) return `Server error (${status}). The team has been notified — please retry in a moment.`;
  if (status === 401) return "Invalid email or password.";
  if (status === 403) return "You don't have permission to do that.";
  if (status === 404) return "That doesn't exist anymore.";
  return `Request failed (${status}). Please try again.`;
}

export function buildInviteUrl(pathOrToken) {
  if (!pathOrToken) return "";
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  if (pathOrToken.startsWith("/")) return `${origin}${pathOrToken}`;
  return `${origin}/invite/${pathOrToken}`;
}
